module.exports = __webpack_public_path__ + "img/tpay-vodafone.8e9fab0c.png";